// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"122d6c7e","772":"02413885"}[chunkId] + ".chunk.js";
};